import { Component } from '@angular/core';
import { OnboardingProvider } from '../../../providers/onboarding/onboarding';
import { ToolsProvider } from '../../../providers/tools/tools';

@Component({
  selector: 'preview-mode-overlay',
  templateUrl: 'preview-mode-overlay.html',
})
export class PreviewModeOverlayComponent {
  showMore = false;

  constructor(
    public onboarding: OnboardingProvider,
    public tools: ToolsProvider
  ) {}

  ngOnInit() {
    this.tools.on('closePreviewModal', () => {
      this.showMore = false;
    });
  }

  learnMore() {
    this.showMore = !this.showMore;
  }

  signUp() {
    this.onboarding.startOnboarding('later');
  }
}



// WEBPACK FOOTER //
// ./src/components/preview-mode/preview-mode-overlay/preview-mode-overlay.ts